/* Pet Mommy theme: behaviours shared by page sections. Everything is opt-in by data attribute. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---------- swipe rows on phones: dots under any [data-swipe] ---------- */
  function initSwipe(c) {
    if (c.dataset.swInit) return; c.dataset.swInit = '1';
    var kids = [].slice.call(c.children);
    if (kids.length < 2) return;
    var d = document.createElement('div'); d.className = 'dots2'; d.setAttribute('aria-hidden', 'true');
    kids.forEach(function (k, i) {
      var b = document.createElement('i'); if (i === 0) b.className = 'on';
      b.onclick = function () { c.scrollLeft += k.getBoundingClientRect().left - c.getBoundingClientRect().left - (parseFloat(getComputedStyle(c).paddingLeft) || 0); };
      d.appendChild(b);
    });
    c.parentNode.insertBefore(d, c.nextSibling);
    var tk = false;
    c.addEventListener('scroll', function () {
      if (tk) return; tk = true;
      requestAnimationFrame(function () {
        tk = false;
        var cl = c.getBoundingClientRect().left, best = 0, bd = 1e9;
        kids.forEach(function (k, i) { var dd = Math.abs(k.getBoundingClientRect().left - cl); if (dd < bd) { bd = dd; best = i; } });
        /* scrolled all the way to the end: the last dot is the one that shows */
        if (c.scrollLeft + c.clientWidth >= c.scrollWidth - 2) best = kids.length - 1;
        [].slice.call(d.children).forEach(function (x, i) { x.classList.toggle('on', i === best); });
      });
    }, { passive: true });
  }
  $$('[data-swipe]').forEach(initSwipe);

  /* compare row: start on the card of the model being viewed */
  function scrollCompare() {
    var c = document.querySelector('[data-compare]');
    if (!c || innerWidth > 959) return;
    var cur = c.querySelector('.is-current'); if (!cur) return;
    c.scrollLeft += cur.getBoundingClientRect().left - c.getBoundingClientRect().left;
  }
  scrollCompare(); setTimeout(scrollCompare, 120);

  /* ---------- count up numbers once ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    var cu = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; cu.unobserve(en.target);
        var el = en.target, n = +el.dataset.n, s = performance.now(); if (isNaN(n)) return; el.textContent = '0';
        (function f(now) { var p = Math.min(1, (now - s) / 900), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(n * e); if (p < 1) requestAnimationFrame(f); })(s);
      });
    }, { threshold: .6 });
    $$('[data-n]').forEach(function (e) { cu.observe(e); });
  }

  /* ---------- gentle reveal for blocks that start below the fold ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    var rv = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); rv.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.mmc,.step,.stat,.cc,.pc,.wy,.pf,.ug,.prc,.fb2,.fcr,.sum>div,.ovhead,.vid,.fframe,.ftabs,.wall>*,.bp,.topics,.hr,.ct,.cform,.ct1').forEach(function (e, i) {
      if (e.getBoundingClientRect().top > innerHeight) { e.classList.add('rv'); e.style.transitionDelay = ((i % 3) * 80) + 'ms'; rv.observe(e); }
    });
    $$('.fb2 .fi>.media,.fb2 .fi>.plate,.btsm').forEach(function (e, i) {
      if (e.getBoundingClientRect().top > innerHeight) { e.classList.add('rc2'); e.style.transitionDelay = ((i % 2) * 60) + 'ms'; rv.observe(e); }
    });
  }

  /* ---------- step clips play only while on screen ---------- */
  var clips = $$('video.sv');
  if (reduce) { clips.forEach(function (v) { v.controls = true; }); }
  else if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) { var v = en.target; if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { threshold: .35 });
    clips.forEach(function (v) { v.muted = true; vio.observe(v); });
  }

  /* ---------- section tabs: smooth jump, scroll spy, sliding underline ---------- */
  function jump(id) {
    var el = document.getElementById(id); if (!el) return false;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 120, behavior: reduce ? 'auto' : 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-tabs] a, [data-scroll]'); if (!a) return;
    var id = (a.getAttribute('href') || '').slice(1);
    if (id && jump(id)) e.preventDefault();
  });
  var tabs = document.querySelector('[data-tabs]');
  if (tabs) {
    var links = $$('a', tabs), ids = links.map(function (a) { return a.dataset.t; }), ind = tabs.querySelector('.tind'), tk2 = false, lastCur = undefined, holdUntil = 0, tabsWrap = tabs.querySelector('.wrap');
    if (tabsWrap) { ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { tabsWrap.addEventListener(ev, function () { holdUntil = Date.now() + 2500; }, { passive: true }); }); }
    var spy = function () {
      tk2 = false; var cur = null;
      ids.forEach(function (id) { var el = document.getElementById(id); if (el && el.getBoundingClientRect().top <= 170) cur = id; });
      links.forEach(function (a) { a.setAttribute('aria-current', a.dataset.t === cur ? 'true' : 'false'); });
      var act = tabs.querySelector('a[aria-current=true]');
      if (act && ind) ind.style.transform = 'translateX(' + act.offsetLeft + 'px) scaleX(' + act.offsetWidth + ')';
      else if (ind) ind.style.transform = 'translateX(0) scaleX(0)';
      /* phones: slide the bar sideways so the current section stays in view (not while the visitor is swiping it) */
      if (cur !== lastCur) {
        lastCur = cur;
        if (act && tabsWrap && tabsWrap.scrollWidth > tabsWrap.clientWidth + 4 && Date.now() > holdUntil) {
          var to = act.offsetLeft - (tabsWrap.clientWidth - act.offsetWidth) / 2;
          tabsWrap.scrollTo({ left: Math.max(0, to), behavior: reduce ? 'auto' : 'smooth' });
        }
      }
    };
    window.addEventListener('scroll', function () { if (!tk2) { tk2 = true; setTimeout(spy, 50); } }, { passive: true });
    spy();
  }

  /* tells a callback whether an element is on screen (works on scroll, no observer needed) */
  function watch(el, cb) {
    var last = null, tk = false;
    function check() {
      tk = false;
      var r = el.getBoundingClientRect();
      var v = r.height > 0 && r.top < window.innerHeight * 0.85 && r.bottom > window.innerHeight * 0.15;
      if (v !== last) { last = v; cb(v); }
    }
    window.addEventListener('scroll', function () { if (!tk) { tk = true; setTimeout(check, 80); } }, { passive: true });
    window.addEventListener('resize', check);
    check(); setTimeout(check, 600);
  }
  /* ---------- reviews: blocks and bars fill in once when the section comes into view ---------- */
  var revSec = document.getElementById('reviews');
  if (revSec && !reduce) {
    var revHead = revSec.querySelector('.revhead');
    if (revHead) {
      revSec.classList.add('fill-pre');
      var revDone = false;
      watch(revHead, function (v) { if (v && !revDone) { revDone = true; revSec.classList.add('fill-in'); } });
    }
  }

  /* ---------- feature tabs (Maps, Music, Calls...) ---------- */
  $$('[data-features]').forEach(function (root) {
    var btns = $$('.ftab', root), imgs = $$('.fframe img', root), plays = $$('.fplay', root), vids = $$('.fframe video.ff-video', root), desc = root.querySelector('[data-fdesc]');
    var cur = null, vis = false;
    function syncVideos() {
      vids.forEach(function (v) {
        var on = !!cur && v.dataset.f === cur.dataset.f;
        v.classList.toggle('on', on);
        if (on && vis && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); if (!on) v.currentTime = 0; }
      });
    }
    function set(b) {
      cur = b;
      btns.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      imgs.forEach(function (x) { x.classList.toggle('on', x.dataset.f === b.dataset.f); });
      plays.forEach(function (x) { x.hidden = x.dataset.f !== b.dataset.f; });
      var s = b.querySelector('span'); if (desc && s) desc.textContent = s.textContent;
      syncVideos();
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { vids.forEach(function (v) { v.currentTime = 0; }); set(b); }); });
    if (btns[0]) set(btns[0]);
    var ff = root.querySelector('.fframe');
    if (vids.length && ff) { watch(ff, function (v) { vis = v; syncVideos(); }); }
  });

  /* ---------- FAQ topic chips ---------- */
  $$('[data-chips]').forEach(function (g) {
    var list = g.parentNode.querySelector('[data-faqlist]');
    g.addEventListener('click', function (e) {
      var b = e.target.closest('.chip'); if (!b) return;
      $$('.chip', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (list) $$('details', list).forEach(function (d) { d.hidden = !(b.dataset.c === 'all' || d.dataset.c === b.dataset.c); });
    });
  });

  /* ---------- Home: maps, music, calls tabs (auto rotate while in view, until touched) ---------- */
  $$('[data-media-tabs]').forEach(function (root) {
    var rows = $$('.mr', root), imgs = $$('.mst img', root), vids = $$('.mst video', root), note = root.querySelector('[data-mnote]'), desc = root.querySelector('[data-mdesc]');
    var i = 0, touched = false, hover = false, vis = false;
    function syncVideos() {
      vids.forEach(function (v) {
        var on = +v.dataset.i === i;
        v.classList.toggle('on', on);
        if (on && vis && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); if (!on) v.currentTime = 0; }
      });
    }
    function set(n) {
      i = n;
      rows.forEach(function (x, k) { x.setAttribute('aria-selected', String(k === n)); });
      imgs.forEach(function (x) { x.classList.toggle('on', +x.dataset.i === n); });
      var d = rows[n].querySelector('.md'); if (desc && d) desc.textContent = d.textContent;
      vids.forEach(function (v) { if (+v.dataset.i === n) v.currentTime = 0; });
      syncVideos();
    }
    rows.forEach(function (x) { x.addEventListener('click', function () { touched = true; set(+x.dataset.i); }); });
    root.addEventListener('mouseenter', function () { hover = true; });
    root.addEventListener('mouseleave', function () { hover = false; });
    set(0);
    /* with videos: move to the next tab when a clip ends, until the visitor picks one (then the chosen clip loops) */
    vids.forEach(function (v) {
      v.addEventListener('ended', function () {
        if (reduce) return;
        if (touched) { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else set((i + 1) % rows.length);
      });
    });
    var mst = root.querySelector('.mst');
    if (vids.length && mst) { watch(mst, function (v) { vis = v; syncVideos(); }); }
    if (!reduce && !vids.length) {
      setInterval(function () {
        if (touched || hover) return;
        var r = root.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
        set((i + 1) % rows.length);
      }, 4000);
    }
  });

  /* ---------- Home: fit check ---------- */
  $$('[data-fitcheck]').forEach(function (root) {
    var sel = root.querySelector('[data-fit-select]'), res = root.querySelector('[data-fit-result]'), empty = root.querySelector('[data-fit-empty]'), h = root.querySelector('[data-fit-h]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var b = sel.value; res.hidden = !b; empty.hidden = !!b;
      if (b) h.textContent = b === 'Other' ? 'Good news. Pet Mommy works with most cars.' : 'Good news. Pet Mommy works with most ' + b + ' cars.';
    });
  });

  /* ---------- contact form: friendly check before sending ---------- */
  $$('form#cform').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var err = f.querySelector('[data-form-err]'); if (!err) return;
      var n = f.querySelector('[name="contact[name]"]'), m = f.querySelector('[name="contact[email]"]'), b = f.querySelector('[name="contact[body]"]');
      var ok = n && n.value.trim() && m && /\S+@\S+\.\S+/.test(m.value) && b && b.value.trim();
      if (!ok) { e.preventDefault(); err.textContent = 'Enter your name, a valid email and a message.'; err.hidden = false; }
    });
    f.addEventListener('input', function () { var err = f.querySelector('[data-form-err]'); if (err) err.hidden = true; });
  });

  /* ---------- brand film: play inside the box when clicked ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-src]');
    if (!b || !b.dataset.videoSrc) return;
    var box = document.createElement('div'); box.className = b.className;
    var v = document.createElement('video');
    v.src = b.dataset.videoSrc; v.controls = true; v.autoplay = true; v.playsInline = true; v.setAttribute('playsinline', '');
    function other(e) { if (e.detail !== v && !v.paused) v.pause(); }
    document.addEventListener('pm:sound-start', other);
    v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#000';
    box.appendChild(v); b.replaceWith(box);
    /* when the film finishes, back to the cover picture and play button; the next tap starts it from the beginning */
    v.addEventListener('ended', function () {
      if (document.fullscreenElement && document.exitFullscreen) { try { document.exitFullscreen(); } catch (err) {} }
      if (v.webkitDisplayingFullscreen && v.webkitExitFullscreen) { try { v.webkitExitFullscreen(); } catch (err) {} }
      document.removeEventListener('pm:sound-start', other);
      box.replaceWith(b);
    });
  });
  /* people who ask for less motion get a still picture instead of looping videos */
  if (reduce) { $$('video[autoplay]').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); }); }

  /* ---------- play a YouTube or Vimeo link inside a button ---------- */  function embed(url) {
    var m;
    if ((m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/))) return 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0&playsinline=1';
    if ((m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/))) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return '';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-url]'); if (!b) return;
    var u = b.getAttribute('data-video-url'); if (!u) return;
    var src = embed(u); if (!src) return;
    var f = document.createElement('iframe');
    var host = b.classList.contains('fplay') ? b.parentNode : b;
    f.src = src; f.allow = 'autoplay; fullscreen; picture-in-picture'; f.allowFullscreen = true; f.title = 'Video';
    f.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
    if (host !== b) { host.appendChild(f); b.remove(); return; }
    b.innerHTML = ''; b.appendChild(f); b.removeAttribute('data-video-url');
  });

  /* ---------- play button when a clip cannot start by itself (iPhone Low Power Mode, Reduce Motion) ---------- */
  (function () {
    var icon = '<svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7L8 5Z"/></svg>';
    function cue(host, getVideo, opts) {
      if (!host || host.dataset.cue) return; host.dataset.cue = '1';
      var b = document.createElement('button'); b.type = 'button'; b.className = 'vplay'; b.hidden = true;
      b.setAttribute('aria-label', 'Play video'); b.innerHTML = icon; host.appendChild(b);
      var vis = false, still = 0;
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }, { threshold: .4 }).observe(host); else vis = true;
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var v = getVideo(); if (!v) return;
        v.muted = true; if (reduce) v.loop = false;
        var pr = v.play(); if (pr && pr.then) pr.then(function () { b.hidden = true; }).catch(function () {});
      });
      setInterval(function () {
        var v = getVideo();
        if (!v || !vis || !v.paused || (reduce && opts.skipReduce)) { still = 0; b.hidden = true; return; }
        still += 500;
        if (reduce || still >= 1500) b.hidden = false;
      }, 500);
    }
    $$('[data-features] .fframe').forEach(function (h) { cue(h, function () { return h.querySelector('video.ff-video.on'); }, {}); });
    $$('[data-media-tabs] .mst').forEach(function (h) { cue(h, function () { return h.querySelector('video.on'); }, {}); });
    $$('.step .sw').forEach(function (h) { cue(h, function () { return h.querySelector('video'); }, { skipReduce: true }); });
  })();

  /* ---------- only one video with sound plays at a time (brand film, customer videos) ---------- */
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || v.muted) return;
    document.dispatchEvent(new CustomEvent('pm:sound-start', { detail: v }));
  }, true);

  /* ---------- comparison cards: the feature lists start at the same height in every card, whatever the length of the price note ---------- */
  (function () {
    var groups = $$('.cmpg'); if (!groups.length) return;
    function fit() {
      groups.forEach(function (g) {
        ['h3', '.pr'].forEach(function (sel) {
          var els = $$('.cc ' + sel, g), m = 0;
          els.forEach(function (e) { e.style.minHeight = ''; });
          els.forEach(function (e) { m = Math.max(m, e.getBoundingClientRect().height); });
          els.forEach(function (e) { e.style.minHeight = m + 'px'; });
        });
      });
    }
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    window.addEventListener('load', fit);
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 150); });
  })();
})();
